<template>
  <aside class="side-menu">
    <ul>
      <li v-for="link in links" :key="link.href">
        <a :href="link.href" :class="{ inactive: link.href !== currentPath }">
          <img :src="link.icon" :alt="link.alt">
        </a>
      </li>
    </ul>
  </aside>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();
const currentPath = computed(() => route.path);

const links = [
  { href: '/dashboard', icon: '/icons/dashboard/admin_home.png', alt: 'Dashboard' },
  { href: '/dashboard/products', icon: '/icons/dashboard/admin_products.png', alt: 'Products' },
  { href: '/dashboard/orders', icon: '/icons/dashboard/admin_orders.png', alt: 'Orders' },
  { href: '/dashboard/talents', icon: '/icons/dashboard/admin_talents.png', alt: 'Talents' },
  { href: '/dashboard/categories', icon: '/icons/dashboard/admin_categories.png', alt: 'Categories' },
  { href: '/dashboard/members', icon: '/icons/dashboard/admin_membership.png', alt: 'Members' },
  { href: '/dashboard/reads', icon: '/icons/dashboard/reads.png', alt: 'Reads' },
  { href: '/dashboard/settings', icon: '/icons/settings.png', alt: 'Settings' },
  // Add more links as needed
];
</script>

<style scoped lang="scss">
.side-menu ul {
  list-style: none;
  padding: 0;
  margin: 12px 0;
}

.side-menu li a {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.side-menu li {
  margin: 12px 0;
}

.side-menu a.inactive {
  opacity: 0.25;
}

.side-menu a img {
  width: 24px;
  height: 24px;
  margin: 5px;
}

.side-menu a:hover {
  opacity: 1;
}

.side-menu {
  min-width: 120px;
  padding: 1rem 0;
  border-right: .5px solid #b8b8b8;
  background: $admin-white;
  text-align: center;
}

.main-area {
  flex: 1;
  padding: 2rem;
  background-color: #f4f4f4;
}
</style>
